import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import ModeSelector from '#/trip-planner/components/ModeSelector';
import DetailViewLayout from '#/components/DetailViewLayout';
import DetailNavHeader from '#/shared/components/DetailNavHeader';
import SEO from '#/shared/components/SEO';
import useCurrentQuery from '#/trip-planner/hooks/useCurrentQuery';
import useNavigate from '#/shared/hooks/useNavigate';
import useViewMapControls from '#/map/hooks/useViewMapControls';
import ROUTES from '#/constants/routes';

function TripModeSelectorContainer() {
  const { navigate, generateNavigateBack, generateNavigateClose } =
    useNavigate();
  const saveSettings = () => {
    navigate(ROUTES.planner);
  };
  const planTrip = () => {
    navigate(ROUTES.trip);
  };

  const { currentQuery, setCurrentQueryParam } = useCurrentQuery();
  const { modeSelectorViewOpened, viewClosed } = useViewMapControls();

  useEffect(() => {
    modeSelectorViewOpened();
    return viewClosed;
  }, [modeSelectorViewOpened, viewClosed]);

  const onQueryParamChange = queryParams => {
    Object.entries(queryParams).forEach(entry =>
      setCurrentQueryParam(...entry)
    );
  };

  const [modeOverlayVisible, setModeOverlayVisible] = useState(false);
  const [closeModeOverlay, setCloseModeOverlay] = useState(false);

  const navigateBack = modeOverlayVisible
    ? () => {
        setCloseModeOverlay(true);
      }
    : generateNavigateBack([], ROUTES.planner);

  useEffect(() => {
    if (!modeOverlayVisible) {
      setCloseModeOverlay(false);
    }
  }, [modeOverlayVisible]);

  return (
    <>
      <SEO metadataId="plannerForms" />
      <DetailViewLayout
        top={
          <DetailNavHeader
            onBack={navigateBack}
            onClose={generateNavigateClose([ROUTES.all])}
            content={<FormattedMessage id="planner.transitsettingstitle" />}
          />
        }
        bottom={
          <ModeSelector
            queryParams={currentQuery}
            onQueryParamChange={onQueryParamChange}
            onSaveSettings={saveSettings}
            onPlanTrip={planTrip}
            modeOverlayVisible={modeOverlayVisible}
            setModeOverlayVisible={setModeOverlayVisible}
            closeModeOverlay={closeModeOverlay}
          />
        }
        hasInverseBackground
      />
    </>
  );
}

export default TripModeSelectorContainer;
